import { maxStringLength, notEmptyWithMsg } from 'z3k-parser/validation/basic';
import { all, validate_by_specification } from 'z3k-parser/validation/collections';
// export const validate_notifications =
//     validate_by_specification<MaintenanceNotificationState>({
//         mileage: orNull(minMax(0, 10000000, 'Слишком рано просите напомнить')),
//         moto_hours: orNull(minMax(0, 10000000, 'Слишком рано просите напомнить')),
//         date: orNull(minMax(0, 100000000, 'Слишком рано просите напомнить')),
//     });
//
// export const validate_repeat = validate_by_specification<MaintenanceNotificationState>({
//     mileage: orNull(minMax(0, 100000000, 'Слишком редкое событие')),
//     moto_hours: orNull(minMax(0, 100000000, 'Слишком редкое событие')),
//     date: orNull(minMax(0, 1000000000, 'Слишком редкое событие')),
// });
//
// export const validate_planned = validate_by_specification<MileageUnitState>({
//     mileage: orNull(minMax(0, 100000000, 'Ещё ни одна машина столько не пробежала...')),
//     moto_hours: orNull(
//         minMax(0, 100000000, 'Ещё ни одна машина столько не пробежала...')
//     ),
// });
//
// export const validate_maintenance = validate_by_specification<PlannedMaintenanceState>({
//     name: all(
//         notEmptyWithMsg('Необходимо название'),
//         maxStringLength(1000, 'Слишком длинное название')
//     ),
//     materials: all(maxStringLength(100000, 'Слишком длинный список материалов')),
//     operations: all(maxStringLength(100000, 'Слишком длинный список операций')),
//     price: all(maxStringLength(1000, 'Слишком длинная стоимость')),
//     // notification: validate_notifications,
//     // repeat: validate_repeat,
//     // planned: validate_planned,
// });
export const validate_history_maintenance = validate_by_specification({
    name: all(notEmptyWithMsg('Необходимо название'), maxStringLength(1000, 'Слишком длинное название')),
    materials: all(maxStringLength(100000, 'Слишком длинный список материалов')),
    operations: all(maxStringLength(100000, 'Слишком длинный список операций')),
    price: all(maxStringLength(1000, 'Слишком длинная стоимость')),
    // performed: validate_planned,
});
